// Enum mappings for display
export const GENDER_MAP: Record<string, string> = {
	male: 'Male',
	female: 'Female',
	other: 'Other'
};

export const SEXUAL_ORIENTATION_MAP: Record<string, string> = {
	heterosexual: 'Heterosexual',
	homosexual: 'Homosexual',
	bisexual: 'Bisexual',
	asexual: 'Asexual',
	pansexual: 'Pansexual',
	other: 'Other'
};

export const STATUS_MAP: Record<string, string> = {
	active: 'Active',
	notactive: 'Not Active'
};

export const PLATFORM_MAP: Record<string, string> = {
	instagram: 'Instagram',
	vsco: 'VSCO',
	tiktok: 'TikTok',
	x: 'X (Twitter)',
	twitter: 'X (Twitter)',
	snapchat: 'Snapchat',
	spotify: 'Spotify'
};

